
import { getProcessTrainingTimeList, appointmentTraining} from '@/api/trainning.js'
import { formatDate } from '@/utils/date.js'
const processTraining = {
  namespaced: true,

  state: {
    viewRange: {
      start: new Date(),
      end: new Date()
    },
    events: [],
    selects: [],
    currentDate: new Date(),
    loading: false,
    hadInited: false,
    canSubmit: true,
    errorText: 'errorText',
    initEvents: [],
    rescheduleReason:'',
    userName:'',
    submitLoading:false
  },
  mutations: {
    SET_VIEW_RANGE: (state, viewRange) => {
      state.viewRange = viewRange
    },
    SET_LOADING: (state, loading) => {
      state.loading = loading
    },
    SETCANSUBMIT: (state, canSubmit) => {
      state.canSubmit = canSubmit
    },
    SET_SUBMIT_LOADING:(state,submitLoading)=>{
      state.submitLoading = submitLoading
    },
    SETERRORTEXT: (state, errorText) => {
      state.errorText = errorText
    },
    SET_CURRENT_DATE: (state, date) => {
      state.currentDate = date
      console.log('date====', state.currentDate)
    },
    SET_EVENTS: (state, events) => {
      state.events = events
      state.initEvents = Object.assign([],events)
    },
    UPDATE_EVENTS: (state, array) => {
      
      let arr = state.events.map(i => { //设置单个日期状态
        if(i.Status === 'Waited') i.Status = ""
        if (i.ScheduleStart === array.ScheduleStart) {
          if (i.Status === '') {
            i.Status = 'Waited'
          } 
          array.Status=i.Status
        }
        return i
      })

      state.events=arr
      state.canSubmit = true
    },
    UPDATE_SELECTS: (state, flag) => {
      let arr = state.events.filter(item => 
        item.Status === 'Waited'
      )
      state.selects = arr
    },
    SET_HAD_INITED: (state, value) => {
      state.hadInited = value
    },
    SET_RESCHEDULEREASON: (state, value) =>{
        state.rescheduleReason = value
    },
    SET_USERNAME: (state,value) =>{
      state.userName = value
    }
  },
  actions: {
    setCanSubmit ({ commit }, value) {
      commit('SETCANSUBMIT', value)
    },
    setErrorText ({ commit }, value) {
      commit('SETERRORTEXT', value)
    },
    upEvents ({ commit }, array) {
      commit('UPDATE_EVENTS', array)
      commit('UPDATE_SELECTS', array)
    },
    setCurrentDate ({ commit }, date) {
      commit('SET_CURRENT_DATE', date)
    },
    setRescheduleReason({commit}, reason){
        commit('SET_RESCHEDULEREASON',reason)
    },
    setUserName({commit}, value){
      commit('SET_USERNAME',value)
    },
    // 这个action在每次切换日期的时候都会被调用, 判断缓存的数据范围是否改变并更新数据
    setViewRange ({ commit, dispatch, state }, { start, end }) {
      // 第一次设置事件范围的时候,标记已初始化
      if (state.hadInited === false) {
        commit('SET_HAD_INITED', true)
      }
      if (
        state.viewRange.start.getTime() === start.getTime() &&
        state.viewRange.end.getTime() === end.getTime()
      ) {
        return
      }
      commit('SET_VIEW_RANGE', {
        start,
        end
      })
      dispatch('fetchData')
    },
    async fetchData ({ commit, state }) {
      commit('SET_LOADING', true)
      getProcessTrainingTimeList(formatDate(state.viewRange.start,'yyyy-MM-dd hh:mm:ss'), formatDate(state.viewRange.end,'yyyy-MM-dd hh:mm:ss'))
        .then(res => {
          if(res.data.Body){
            res = res.data.Body.map(i=>{
              i.Status = ""
              return i
            })
            commit('SET_EVENTS', res)
          }
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    },
    addSchedule ({ commit, dispatch, state }) {
      commit('SET_SUBMIT_LOADING',true)
      appointmentTraining(state.selects[0].ScheduleStart,state.selects[0].ScheduleEnd,state.rescheduleReason,state.userName)
        .then(res => {
          commit('SETERRORTEXT', res.data.Body)
        })
        .finally(() => {
          commit('SET_SUBMIT_LOADING',false)
          dispatch('fetchData')
          commit('SETCANSUBMIT', false)
          commit('SET_RESCHEDULEREASON','')
        })
    },
    prev ({ commit, state, dispatch }) {
      const prev = new Date(state.currentDate.getTime())
      prev.setDate(prev.getDate() - 7)
      commit('SET_CURRENT_DATE', prev)
      commit('SETCANSUBMIT', false)
    },
    next ({ commit, state, dispatch }) {
      const next = new Date(state.currentDate.getTime())
      next.setDate(next.getDate() + 7)
      commit('SET_CURRENT_DATE', next)
      commit('SETCANSUBMIT', false)

    }
  },
  getters: {
    events: state => state.events,
    initEvents: state => state.initEvents,
    currentDate: state => state.currentDate,
    loading: state => state.loading,
    submitLoading: state => state.submitLoading,
    viewRange: state => state.viewRange,
    hadInited: state => state.hadInited,
    errorText: state => state.errorText,
  }
}
export default processTraining
